import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { UserSettingService } from '../share/services/User-Setting/user-setting.service';
import { AuthService } from '../home/auth/auth.service';
import { StorageService } from '../share/services/storage-service/storage.service';
import { StorageKeys } from '../share/enums/storage.enum';
import { CommonService } from '../share/services/common/common.service';

@Component({
    selector: 'app-home-layout',
    template: `

<!--
<app-header></app-header>
-->
<!--<div class="row m-0">
<div class="col-md-2 g-0 vh-100 side-bar theme-bg-color position-fixed ">
  &lt;!&ndash;      <app-sidebar></app-sidebar>&ndash;&gt;
  <app-side-nav-bar></app-side-nav-bar>
</div>
<div class="offset-2 col-md-10 theme-body-bg-color body-container">
  <router-outlet></router-outlet>
</div>
</div>-->
<div class="login-layout">
  @if (!hideSidebar) {
    <div>
      <app-sidebar></app-sidebar>
    </div>
  }
  <div class="route-section">
    <router-outlet></router-outlet>
  </div>
</div>
<!--
<app-footer></app-footer>
-->
`,
    styles: [`.body-container{
    background-color : white
  }
  .offset-2{
    padding-bottom: 60px;
  }
  .side-bar{
    z-index: 99;
  }
  .route-section{
    min-width: calc(100% - 180px);
    flex-grow: 1;
    padding: 36px 29px 19px 26px;
  }`
    ],
    standalone: false
})
export class HomeLayoutComponent implements OnInit {
  hideSidebar: boolean = false;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly authService: AuthService,
    private readonly storageService: StorageService,
    private readonly userSettingService: UserSettingService,
    private readonly commonService: CommonService
  ) { }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      const accessToken = params['accessToken'];
      const hideNavBar = params['hideNavBar'];
      const apiKey = params['apikey'];
      if (hideNavBar === 'true' && (accessToken || apiKey)) {
        this.hideSidebar = true;
      } else {
        this.hideSidebar = false;
      }
      if (apiKey) {
        this.loadInitialData();
      }
    });
  }

  loadInitialData() {
    forkJoin({
      selfDetails: this.authService.getSelfDetails().pipe(
        catchError((err) => {
          console.error('Failed to load self details', err);
          return of(null);
        })
      ),
      companyPrefs: this.userSettingService.getCompanyPrefs().pipe(
        catchError((err) => {
          console.error('Failed to load company preferences', err);
          return of(null);
        })
      )
    }).subscribe({
      next: (res: any) => {
        if (res?.selfDetails?.data) {
          this.storageService.setDataToSessionStorage(StorageKeys.SELF_DETAILS, res?.selfDetails?.data);
        }
        if (res?.companyPrefs?.data) {
          this.storageService.setDataToSessionStorage(StorageKeys.PREFERENCES, res?.companyPrefs?.data);
          this.userSettingService.setPrefDetails(res?.companyPrefs?.data);
        }
        this.commonService.markSelfDetailsReady();
      }
    });
  }

}
